const $ = jQuery;

/**
 * Class accordion
 */
class Accordion {
	/**
	 * Constructor
	 *
	 * @param {jQuery} element jQuery bellow element.
	 */
	constructor(element) {
		this.accordion = element;
		this.triggers = this.accordion.find('.block-bellow__top');
		this.transition = 400;

		this.triggers.on('click', this.handleBellowClick.bind(this));
		this.triggers.on('keydown', this.handleBellowKeydown.bind(this));
	}

	/**
	 * Handle bellow click
	 *
	 * @param {Event} event
	 */
	handleBellowClick(event) {
		this.toggleBellow(event.currentTarget);
	}

	/**
	 * Handle bellow keydown
	 *
	 * @param {Event} event
	 */
	handleBellowKeydown(event) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault(); // Prevent scrolling when space is pressed
			this.toggleBellow(event.currentTarget);
		}
	}

	/**
	 * Toggle Bellow
	 *
	 * @param {Object} target Event target
	 */
	toggleBellow(target) {
		const isExpanded = target
			.closest('.block-bellow')
			.classList.contains('block-bellow--expanded');

		if (isExpanded) {
			this.collapseBellow(target);
		} else {
			this.expandBellow(target);
		}
	}

	/**
	 * Collapse Bellow
	 *
	 * @param {Object} target Event target
	 */
	collapseBellow(target) {
		const bellowTrigger = $(target);

		bellowTrigger
			.attr('aria-expanded', 'false')
			.parents('.block-bellow')
			.removeClass('block-bellow--expanded')
			.find('.block-bellow__collapsable')
			.slideUp(this.transition);
	}

	/**
	 * Expand Bellow
	 *
	 * @param {Object} target Event target
	 */
	expandBellow(target) {
		const bellow = $(target);

		// Collapse other bellow if exists and not multiple open by default.
		const expandedBellow = document.querySelector('.block-bellow--expanded .block-bellow__top');
		if (null !== expandedBellow && $('.block-bellow--open-default').length < 2) {
			this.collapseBellow(expandedBellow);
		}

		// Expand bellow.
		bellow
			.attr('aria-expanded', 'true')
			.parents('.block-bellow')
			.addClass('block-bellow--expanded')
			.find('.block-bellow__collapsable')
			.slideDown(this.transition);
	}
}

$('.block-accordion').each(function () {
	new Accordion($(this));
});
